import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import styled from 'styled-components';


/* import CSS for datepicker */
import 'react-day-picker/lib/style.css';

/* importing Bootstrap styles */
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';

/* import main CSS for app */
import './styles/styles.css';

/* import global components */
import Header from './components/shared/header';

/* import our components */
import SearchForm from './components/searchForm/searchForm';
import SearchResults from './components/searchResults/searchResults';
import TextView from './components/textView/textView';

import Home from './staticContent/home/home';


const FormContainer = styled.div`
  width: auto;
  padding: 0 30px;
  margin: 0px auto;

  label {
    color: #666;
  }

  label:hover {
    cursor: pointer;
  }

  h3.formTitle {
    font-size: 23px;
    line-height: 33px;
    color: #777;
    font-weight:400;
    margin:10px 0;
  }
`;

class App extends Component {
  render() {
    return (
      <Router>
        <React.Fragment>
          <Header />
          <FormContainer> 
              { process.env.REACT_APP_ISSECURE === 'false' &&
                <React.Fragment>
                  <Route exact path='/' render={() =>
                    (<Redirect to="/SitePages" />)
                  }/>
                  <Route exact path='/SitePages' component={Home} />                               
                  
                </React.Fragment>
              }
              
              { process.env.REACT_APP_ISSECURE === 'true' &&
                <Route exact path='/' render={() =>
                  (<Redirect to="/rjr/4b" />)
                }/>
              }
              { process.env.REACT_APP_ISSECURE === 'false' &&
                <Route exact path='/4b' component={() => window.location = 'http://4b.rjrtdocs.com/rjr/4b'}/>
              }
              
              <Route exact path='/:formBrand/:formType' component={SearchForm}/>
              <Route exact path='/:formBrand/:formType/searchResults' component={SearchResults}/>
              <Route exact path='/:formBrand/:formType/fileData/:fileACC' component={TextView}/>

          </FormContainer>
        </React.Fragment>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js